/**
 * `full` keys act as the whole organization. `trigger` keys are handed to client systems: they can
 * trigger workflows and manage subscribers and topics, and are rejected everywhere else.
 */
export var ApiKeyScopeEnum;
(function (ApiKeyScopeEnum) {
    ApiKeyScopeEnum["FULL"] = "full";
    ApiKeyScopeEnum["TRIGGER"] = "trigger";
})(ApiKeyScopeEnum || (ApiKeyScopeEnum = {}));
//# sourceMappingURL=apiKeys.interface.js.map